import http from "../../http-common";

const ProductTagParametersService = {
    search: request => http.post("/ProductEan/FilterProductEan", request),
    save: request => http.post("/ProductEan/InsertUpdateProductEan", request),
    searchByIdProduto: request => http.post("/ProductEan/SelectProductEan", request),
    delete: id => http.delete("/ProductEan/", {
        headers: {
            id: id
        }
    })
}

export default ProductTagParametersService;

